import PropTypes from 'prop-types';
import React from 'react';
import { SimpleSelectField } from '@unite-us/app-components';
import { caseTypeOptions } from 'src/components/Cases/utils';
import {
  propagateSelectBlur,
  propagateSelectChange,
  resolveFieldError,
  resolveSelectedValue,
} from './selectFieldHelpers';

const CaseTypeField = ({
  group,
  hasGroupLicense,
  hasNetworkLicense,
  input,
  meta,
  onChange,
  ...props
}) => {
  const options = React.useMemo(
    () => caseTypeOptions(group.name, hasNetworkLicense).map((option) => ({
      value: option.type,
      label: option.name,
    })),
    [group.name, hasNetworkLicense],
  );

  const value = React.useMemo(
    () => resolveSelectedValue(input?.value, 'type'),
    [input?.value],
  );

  const inputRef = React.useRef(input);
  React.useEffect(() => {
    inputRef.current = input;
  }, [input]);

  const handleChange = React.useCallback((newValue) => {
    propagateSelectChange({ inputRef, onChange, value: newValue });
  }, [onChange]);

  const handleBlur = React.useCallback(
    () => propagateSelectBlur(inputRef),
    [],
  );

  return (
    <SimpleSelectField
      disabled={hasGroupLicense && !hasNetworkLicense}
      options={options}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      required
      searchable={false}
      clearable={false}
      error={resolveFieldError(meta)}
      {...props}
    />
  );
};

CaseTypeField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  group: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  hasGroupLicense: PropTypes.bool.isRequired,
  hasNetworkLicense: PropTypes.bool.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

CaseTypeField.defaultProps = {
  id: 'case-type',
  label: 'Case Type',
  required: true,
  disabled: false,
  meta: undefined,
  onChange: undefined,
};

export default CaseTypeField;
